import type { ModuleConfig } from '../../core/module';
import { reportsManagementRoutes } from './routes';

export const ReportsManagementModule: ModuleConfig = {
  name: 'reports-management',
  routes: reportsManagementRoutes,
  stores: {},
  initialize: () => {
    console.log('Reports Management module initialized');
  },
  cleanup: () => {
    console.log('Reports Management module cleaned up');
  },
};

// Re-export types and hooks
export * from './types';
export * from './hooks/useReportsManagement';
export * from './hooks/useReportCustomization';
export * from './hooks/useTemplateAdmin';
export * from './types/template';
